import { render, staticRenderFns } from "./ThanksEmailVerified.vue?vue&type=template&id=05d20972&scoped=true"
import script from "./ThanksEmailVerified.vue?vue&type=script&lang=js"
export * from "./ThanksEmailVerified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d20972",
  null
  
)

export default component.exports